// PythonFormatter.js
export const formatPython = (code) => {
  try {
    if (!code) return { convertedData: '', isError: false };

    const lines = code.split('\n');

    let indentLevel = 0;
    const formatted = lines.map(line => {
      let trimmed = line.trim();

      // Adjust indent for dedent keywords
      if (/^(return|pass|break|continue|raise|elif|else|except|finally)/.test(trimmed)) {
        indentLevel = Math.max(indentLevel - 1, 0);
      }

      const indentedLine = '  '.repeat(indentLevel) + trimmed;

      // Increase indent after these keywords
      if (/(def |class |if |for |while |else:|elif |try:|except |finally:)$/.test(trimmed)) {
        indentLevel++;
      }

      return indentedLine;
    });

    return { convertedData: formatted.join('\n'), isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid Python code', isError: true };
  }
};


// TypeScriptFormatter.js
export const formatTypeScript = (code) => {
  try {
    if (!code) return { convertedData: '', isError: false };

    // Add newlines after semicolons, braces, and commas
    let formatted = code
      .replace(/;\s*/g, ';\n')
      .replace(/{\s*/g, '{\n')
      .replace(/}\s*/g, '\n}\n')
      .replace(/,\s*/g, ', ')
      .replace(/\n\s*\n/g, '\n') // remove extra empty lines
      .split('\n')
      .map(line => line.trim())
      .join('\n');

    // Indentation based on braces
    let indent = 0;
    const lines = formatted.split('\n');
    const indented = lines.map(line => {
      if (line.includes('}')) indent = Math.max(indent - 1, 0);
      const indentedLine = '  '.repeat(indent) + line;
      if (line.includes('{')) indent++;
      return indentedLine;
    }).join('\n');

    return { convertedData: indented, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid TypeScript code', isError: true };
  }
};

export const formatCss = (css) => {
    // Simple formatting: add line breaks and indentation
    return css
        .replace(/\s*{\s*/g, " {\n  ")
        .replace(/\s*}\s*/g, "\n}\n")
        .replace(/\s*;\s*/g, ";\n  ")
        .replace(/\s*:\s*/g, ": ");
};
